import { walterBIApi } from '../clients/AxiosClients'

const getDashBoardById = async () => {
	return walterBIApi.get(
		'v1/DashboardSingleTrees/GetDashboardData?estratoInventarioFlorestalId=1216e87d-2f46-469d-a09d-d9845faf3936',
	)
}

/**
 * Retorna os KPIS de todas as fazendas
 */
const getKpiDashboardGeral = async (cancelToken) => {
	return await walterBIApi.get('v2/DashboardAgility/busca-kpi-dashboard-geral', { cancelToken })
}

export const getReportNanorads = async () => {
	return await walterBIApi.get('v1/DashboardCustomizado/nanorads')
}

export const getReportBracell = async () => {
	return await walterBIApi.get('v1/DashboardCustomizado/bracell')
}

export const getReportMaxima = async () => {
	return await walterBIApi.get('v1/DashboardCustomizado/maxima')
}

export const getEmbedToken = async () => {
	return await walterBIApi.get('v1/DashboardCustomizado/getEmbedToken')
}

export const getReports = async () => {
	return await walterBIApi.get('v1/DashboardCustomizado/getReports')
}

export const getEmbedTokenByReportId = async (reportId) => {
	return await walterBIApi.get(`v1/DashboardCustomizado/getEmbedToken/${reportId}`)
}

/**
 * Retorna os KPIS de uma fazenda especifica passada por parametro
 */
const getKpiDashboardFazenda = async (fazendaId, cancelToken) => {
	return await walterBIApi.get(
		`v2/DashboardAgility/busca-kpi-dashboard-fazenda/?fazendaId=${fazendaId}`,
		{ cancelToken },
	)
}

/**
 * Retorna todos os ultimos inventarios de plantio agrupados por material genetico
 */
const getAllInventarioPlantioByMaterialGenetico = async (cancelToken) => {
	return await walterBIApi.get(
		'v2/DashboardAgility/lista-inventarios-plantios-por-material-genetico',
		{ cancelToken },
	)
}

/**
 *  Retorna todos os ultimos inventarios de plantio de uma determinada fazenda agrupados por material genetico
 */
const getInventarioPlantioGroupedByMaterialGeneticoEqualsFazendaId = async (
	fazendaId,
	cancelToken,
) => {
	return await walterBIApi.get(
		`v2/DashboardAgility/busca-inventarios-plantios-agrupados-por-material-genetico-pelo-fazenda-id/?fazendaId=${fazendaId}`,
		{ cancelToken },
	)
}

/**
 * Recupera todos os ultimos inventarios de plantio agrupados por faixa de idade
 */
const getAllInventarioPlantioByFaixaDeIdade = async (cancelToken) => {
	return await walterBIApi.get(
		'v2/DashboardAgility/lista-inventarios-plantios-por-faixa-de-idade',
		{ cancelToken },
	)
}

/**
 *  Retorna todos os ultimos inventarios de plantio de uma determninada fazenda agrupados por faixa de idade
 */
const getInventarioPlantioGroupedByFaixaDeIdadeEqualsFazendaId = async (fazendaId, cancelToken) => {
	return await walterBIApi.get(
		`v2/DashboardAgility/busca-inventarios-plantios-agrupados-por-faixa-de-idade-pelo-fazenda-id/?fazendaId=${fazendaId}`,
		{ cancelToken },
	)
}

/**
 * Retorna os inventarios florestais e inventarios de plantios com o historico
 * da idade
 */
const getInventarioFlorestalComInventarioPlantio = async (cancelToken) => {
	return await walterBIApi.get(
		'v2/DashboardAgility/busca-inventarios-florestais-com-inventarios-plantios',
		{ cancelToken },
	)
}

/**
 * Retorna os valores para preencher os CardMapInfo da tela de dashboard
 * com algumas informacoes de todas as fazendas
 */
const getCardMapInfoFazendas = async (cancelToken) => {
	return await walterBIApi.get('v2/DashboardAgility/busca-card-map-info-fazenda', { cancelToken })
}

/**
 * Retorna os dados de poligonos de todas as fazendas para a tela de
 * dashboard
 */
const getCardMapInfoFazendasPoligonos = async (cancelToken) => {
	return await walterBIApi.get('v2/DashboardAgility/busca-card-map-info-fazendas-poligonos', {
		cancelToken,
	})
}

/**
 * Recupera qual a data do ultimo inventario florestal processado entre todas as fazendas
 * @returns Data do ultimo inventairo florestal
 */
const getDataUltimoProcessamento = async (cancelToken) => {
	return await walterBIApi.get('v2/DashboardAgility/busca-data-dos-inventarios-oficiais', {
		cancelToken,
	})
}

/**
 * Retorna os dados do ultimo processamento de cada estrato de uma determinada fazenda passada por parametro
 */
const getCardMapInfoEstratos = async (fazendaId, cancelToken) => {
	return await walterBIApi.get(
		`v2/DashboardAgility/busca-card-map-info-estratos-pelo-fazenda-id/?fazendaId=${fazendaId}`,
		{ cancelToken },
	)
}

/**
 * Retorna os poligonos dos estratos de fanzendas para preencher o cardMapInfo
 * @param {Guid} fazendaId Id da fazenda que esta sendo buscado as informacoes
 */
const getCardMapInfoFazendasPoligonosByFazendaId = async (fazendaId, cancelToken) => {
	return await walterBIApi.get(
		`v2/DashboardAgility/busca-card-map-info-fazendas-poligonos-pelo-fazenda-id/?fazendaId=${fazendaId}`,
		{ cancelToken },
	)
}

/**
 * Retorna as Categorias de Arvores e a quantidade de cada categoria que estao na fazenda passada por parametro
 */
const getQuantidadeDeArvoresPorCategoriaByFazendaId = async (fazendaId, cancelToken) => {
	return await walterBIApi.get(
		`v2/DashboardAgility/busca-quantidades-de-arvores-por-categoria-pelo-fazenda-id/?fazendaId=${fazendaId}`,
		{ cancelToken },
	)
}

/**
 * Retorna arvores uteis e nao uteis que estao na fazenda passada por parametro
 */
const getProporcaoDeArvoresUteisByFazendaId = async (fazendaId, cancelToken) => {
	return await walterBIApi.get(
		`v2/DashboardAgility/busca-proporcao-de-aarvores-uteis-pelo-fazenda-id/?fazendaId=${fazendaId}`,
		{ cancelToken },
	)
}
/**
 * Retorna arvores uteis e nao uteis separados por plantio dos plantios que estao na fazenda passada por parametro
 */
const getProporcaoDeArvoresUteisGroupedByPlantioEqualsFazendaId = async (
	fazendaId,
	cancelToken,
) => {
	return await walterBIApi.get(
		`v2/DashboardAgility/busca-proporcao-de-arvores-uteis-agrupado-por-plantio-pelo-fazenda-id/?fazendaId=${fazendaId}`,
		{ cancelToken },
	)
}

/**
 * Retorna os markers de um estrato de inventario florestal para preencher no mapa do dashboard
 * @param {Guid} estratoInventarioFlorestalId
 */
const getPlantioMarkers = async (estratoInventarioFlorestalId, cancelToken) => {
	return await walterBIApi.get(
		`v2/DashboardAgility/busca-plantio-markers/?estratoFlorestalId=${estratoInventarioFlorestalId}`,
		{ cancelToken },
	)
}

/**
 * Recupera qual a data do ultimo inventario florestal processado entre todas as fazendas
 * @returns Data do ultimo inventairo florestal
 */
const getDataUltimoProcessamentoByFazendaId = async (fazendaId, cancelToken) => {
	const params = { fazendaId }
	return await walterBIApi.get(
		'v2/DashboardAgility/busca-data-ultimo-processamento-por-fazenda-id',
		{ params, cancelToken },
	)
}

const getUltimoProcessamentoByFazendaId = async (fazendaId, cancelToken) => {
	const params = { fazendaId }
	return await walterBIApi.get(
		'v2/DashboardAgility/busca-data-ultimo-processamento-por-fazenda-id',
		{ params, cancelToken },
	)
}

export const GetDashboardData = async (estratoInventarioFlorestalId = '', cancelToken) => {
	return await walterBIApi.get(
		`v2/DashboardAgility/GetDashboardData?estratoInventarioFlorestalId=${estratoInventarioFlorestalId}`,
		{ cancelToken },
	)
}

export const getHistoricoNivelPovoamentoEstrato = async (fazendaId, cancelToken) => {
	return await walterBIApi.get(
		`v2/DashboardAgility/historico-nivel-de-povoamento-estrato?fazendaId=${fazendaId}`,
		{ cancelToken },
	)
}

export const getHistoricoNivelPovoamentoTalhao = async (fazendaId, cancelToken) => {
	return await walterBIApi.get(
		`v2/DashboardAgility/historico-nivel-de-povoamento-talhao?fazendaId=${fazendaId}`,
		{ cancelToken },
	)
}

export const getHistoricoNivelPovoamentoArvore = async (fazendaId, cancelToken) => {
	return await walterBIApi.get(
		`v2/DashboardAgility/historico-nivel-de-povoamento-arvore?fazendaId=${fazendaId}`,
		{ cancelToken },
	)
}

export const getDropdownProcessamentoSortimento = async (fazendaId, cancelToken) => {
	return await walterBIApi.get(
		`v2/DashboardAgility/buscar-dropdown-de-sortimentos-subsequentes-por-id-de-fazenda?fazendaId=${fazendaId}`,
		{ cancelToken },
	)
}

export const getSortimentoByInventarioFlorestalId = async (invenrarioFlorestalId, cancelToken) => {
	return await walterBIApi.get(
		`v2/DashboardAgility/buscar-sortimento-por-inventario-florestal?inventarioFlorestalId=${invenrarioFlorestalId}`,
		{ cancelToken },
	)
}

export const getPlantiosMapByFazendaId = async (fazendaId, cancelToken) => {
	return await walterBIApi.get(`v1/GIS/GetPlantiosMapByFazendaId?fazendaId=${fazendaId}`, {
		cancelToken,
	})
}

export const getPoligonosByInventarioIdList = async (inventarioIds, cancelToken) => {
	return await walterBIApi.get(
		'v2/DashboardAgility/buscar-poligonos-e-propriedades-para-os-inventarios',
		{
			params: {
				idsInventariosFlorestais: inventarioIds,
			},
			paramsSerializer: {
				indexes: null,
			},
			cancelToken,
		},
	)
}

export const getDashboardDataByInventarioIdList = async (inventarioIds, cancelToken) => {
	return await walterBIApi.get(
		'v2/DashboardAgility/buscar-dados-calculados-para-grupo-de-inventarios-florestais',
		{
			params: {
				idsInventariosFlorestais: inventarioIds,
			},
			paramsSerializer: {
				indexes: null,
			},
			cancelToken,
		},
	)
}

export const getEstratosByFazendaId = async (fazendaId) => {
	return await walterBIApi.get(
		`v2/DashboardAgility/buscar-ultimos-processamentos-por-estrato-florestal-a-nivel-de-fazenda?fazendaId=${fazendaId}`,
	)
}

export const getProcessamentosByEstratoId = async (estratoFlorestalId) => {
	return await walterBIApi.get(
		`v2/DashboardAgility/buscar-processamentos-por-id-estrato-florestal?estratoFlorestalId=${estratoFlorestalId}`,
	)
}

export const getNivelPovoamentoByInventarioFlorestalId = async (inventarioFlorestalId) => {
	return await walterBIApi.get(
		`v2/DashboardAgility/buscar-nivel-de-povoamento-por-id-de-estrato-florestal?estratoInventarioFlorestalId=${inventarioFlorestalId}`,
	)
}

export {
	getAllInventarioPlantioByFaixaDeIdade,
	getAllInventarioPlantioByMaterialGenetico,
	getCardMapInfoEstratos,
	getCardMapInfoFazendas,
	getCardMapInfoFazendasPoligonos,
	getCardMapInfoFazendasPoligonosByFazendaId,
	getDashBoardById,
	getDataUltimoProcessamento,
	getDataUltimoProcessamentoByFazendaId,
	getInventarioFlorestalComInventarioPlantio,
	getInventarioPlantioGroupedByFaixaDeIdadeEqualsFazendaId,
	getInventarioPlantioGroupedByMaterialGeneticoEqualsFazendaId,
	getKpiDashboardFazenda,
	getKpiDashboardGeral,
	getPlantioMarkers,
	getProporcaoDeArvoresUteisByFazendaId,
	getProporcaoDeArvoresUteisGroupedByPlantioEqualsFazendaId,
	getQuantidadeDeArvoresPorCategoriaByFazendaId,
	getUltimoProcessamentoByFazendaId,
}
